import { render, staticRenderFns } from "./patientDetails.vue?vue&type=template&id=788a9d1c&scoped=true&"
import script from "./patientDetails.vue?vue&type=script&lang=js&"
export * from "./patientDetails.vue?vue&type=script&lang=js&"
import style0 from "./patientDetails.vue?vue&type=style&index=0&id=788a9d1c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788a9d1c",
  null
  
)

export default component.exports